import { ca } from '@cian/analytics';

import { type IPromo } from '../../types/promos';
import { getProductsData } from '../../utils/getProductsData';

export function trackCianMortgageClick(promo: IPromo): void {
  const { promoType, uniquePromoId: promoCianMortgage } = promo;

  ca('eventSite', {
    action: 'click_morgage',
    category: 'Promo',
    label: promoType,
    name: 'oldevent',
    products: [getProductsData({ promoCianMortgage })],
  });
}
